import { toFixed } from '../../../../core/services/utils/numbers';

/** Value Object com regras de negócio dos pesos dos itens de pedidos */
export class PedidoItemPesoValueObject {
    private _quantidade: number;
    private _pesoUnitario: number;
    private _pesoTotal: number;

    constructor(quantidade: number, pesoUnitario: number) {
        this._quantidade = quantidade;
        this._pesoUnitario = pesoUnitario;

        // Calculando o peso total
        this.calcularTotal();
    }

    /** Calcula o peso total multiplicando a quantidade pelo peso unitário */
    private calcularTotal() {
        const pesoTotal = this._quantidade * this._pesoUnitario;
        this._pesoTotal = toFixed(pesoTotal, 6);
    }

    /** Obtem o peso total calculado */
    get pesoTotal(): number {
        return this._pesoTotal;
    }
}
